export default {
  stepContainerBackground: 'var(--digi-blue-100)',
  stepContainerBackgroundAfter: 'var(--digi-blue-400)',
};
